import { render } from "./ObjetoList.vue?vue&type=template&id=150999b0&scoped=true"
import script from "./ObjetoList.vue?vue&type=script&lang=js"
export * from "./ObjetoList.vue?vue&type=script&lang=js"

import "./ObjetoList.vue?vue&type=style&index=0&id=150999b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150999b0"]])

export default __exports__